(function() {

  // Initialize all swipers with proper pagination
  function initSwipers() {
    const carousels = document.querySelectorAll('.product-item__carousel.swiper-container');
    if (!carousels.length) return;


    carousels.forEach((container) => {
      if (container.swiper) {
        container.swiper.destroy();
      }

      // Prevent navigation on arrow clicks
      const nextBtn = container.querySelector('.swiper-button-next');
      const prevBtn = container.querySelector('.swiper-button-prev');
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      // Mobile-specific configuration
      const isMobile = window.innerWidth <= 749;
      
      // Count real slides
      const slides = container.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      if (slideCount <= 1) return;

      const swiper = new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        speed: 300,
        effect: 'slide',
        preloadImages: true,
        updateOnImagesReady: true,
        watchSlidesProgress: true,
        grabCursor: true,
        
        // Touch Optimizasyonu
        touchRatio: isMobile ? 1.2 : 1,
        longSwipesRatio: 0.3,
        touchAngle: 45,
        threshold: 5,
        followFinger: true,
        shortSwipes: true,
        longSwipes: true,
        
        // Navigation
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        
        // Pagination line update
        on: {
          slideChange: function() {
            updatePaginationLine(container, this.realIndex, slideCount);
          },
          init: function() {
            updatePaginationLine(container, this.realIndex, slideCount);
          }
        }
      });
      
      // Update pagination line function
      function updatePaginationLine(container, currentIndex, totalSlides) {
        const progressBar = container.querySelector('.pagination-progress');
        const paginationLine = container.querySelector('.mobile-pagination-line');
        
        if (progressBar && totalSlides > 1) {
          const progress = ((currentIndex + 1) / totalSlides) * 100;
          progressBar.style.width = progress + '%';
          
          // Ensure pagination line is visible on mobile
          if (isMobile && paginationLine) {
            paginationLine.style.display = 'block';
            paginationLine.style.position = 'absolute';
            paginationLine.style.bottom = '0';
            paginationLine.style.left = '0';
            paginationLine.style.width = '100%';
            paginationLine.style.transform = 'none';
            paginationLine.style.zIndex = '20';
          }
        }
      }
    });
  }

  function onLoad() {
    // Check if Swiper is already loaded
    if (typeof Swiper === 'undefined') {
      // Load Swiper CSS and JS if not already loaded
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
      script.onload = function() {
        // Initialize with a small delay to ensure everything is loaded
        setTimeout(initSwipers, 100);
      };
      script.onerror = function() {
        console.error('Swiper CDN load failed — product carousels disabled');
      };
      document.head.appendChild(script);
    } else {
      initSwipers();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  document.addEventListener('shopify:section:load', onLoad);
  var _resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(initSwipers, 250);
  });
})();